import type { Filter, RegularFilterConfig } from '../../models'
import { FilterTypeEnum } from '../../enums'

export const getRegularFiltersConfig = (
  filters: Record<string, Filter>,
): Record<string, RegularFilterConfig> => {
  return Object.values(filters).reduce(
    (result: Record<string, RegularFilterConfig>, { config }) => {
      if (config.type === FilterTypeEnum.REGULAR) {
        result[config.id] = config as RegularFilterConfig
      }
      return result
    },
    {},
  )
}
